import React from "react";
import AdminPanelPage from "../components/admin/AdminPanelPage";

// Route page wrapper — thin shell so the admin orchestrator stays self-contained.
export default function AdminPage() {
  return <AdminPanelPage />;
}
